import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { appBarHeight } from "../appBar/appBarTheme";

/** Re-export — keep layout calcs aligned with `ModernCustomAppBar`. */
export const analyseAppBarHeight = appBarHeight;

/**
 * Pixels subtracted from 100vh for `contentCard` minHeight on the Analyse page.
 *
 * Breakdown (with default `theme.spacing.unit` = 8):
 * - 48  AppBar / Toolbar (`appBarHeight`, `spacing.unit × 6`)
 * - 72  root `paddingTop` (`spacing.unit × 9`)
 * - 16  margin below tabs row (`spacing.unit × 2`, `tabsContainer.marginBottom`)
 * -  8  layout slack (`spacing.unit × 1`, main padding / rounding)
 * ────
 * 144 total
 */
export const analyseContentCardViewportOffset = (theme: Theme) =>
  appBarHeight(theme) +
  theme.spacing.unit * 9 +
  theme.spacing.unit * 2 +
  theme.spacing.unit;

/** Shared layout tokens for the Analyse section (Tunnelwatch-inspired). */
export const analyseTheme = {
  pageBg: "#eef1f6",
  surface: "#ffffff",
  border: "#e2e6ee",
  borderLight: "#eceff4",
  textPrimary: "#1a2332",
  textSecondary: "#6b7280",
  accent: "#2948ff",
  accentSoft: "rgba(41, 72, 255, 0.08)",
  secondary: "#FF5E62",
  secondaryLight: "#FF9966",
  secondaryDark: "#ba000d",
  secondarySoft: "rgba(255, 153, 102, 0.15)",
  radius: 10,
  radiusSm: 8,
  radiusXs: 4,
  shadow: "none",
};

export const analyseCardStyle = {
  backgroundColor: analyseTheme.surface,
  border: `1px solid ${analyseTheme.border}`,
  borderRadius: analyseTheme.radius,
  boxShadow: analyseTheme.shadow,
};
